<!-- TEMPLATES -->
<ng-template #deleteModal>
  <div class="col-12 m-0 p-0" *ngIf="!openDeleteNotDamage && !openDeleteOther">
    <ul>
      <li *ngFor="let reason of possibleValuesSelectDelete" class="deleteValue">
        <p #li class="deleteValueText" (click)='li.classList.add("liCkick"); selectDelReason($event, reason)'>
          {{reason.value}}
        </p>
      </li>
    </ul>
  </div>
  <div class="col-12 m-0 p-0" *ngIf="openDeleteOther">
    <div class="col-12" style="border-bottom: rgba(169, 169, 172, 0.79) 2px solid;"><i class="fa fa-arrow-left p-2"
        style="cursor: pointer;" aria-hidden="true" (click)='openDeleteOther = false'></i>
    </div>
    <div class="col-12 mt-1 mb-1">
      <input type="text" i18n-placeholder="modal_damage|@@Comment" placeholder="Commentaire..."
        [(ngModel)]="otherDelete">
    </div>
    <div class="col-12 mt-1 mb-1">
      <button *ngIf="otherDelete && otherDelete.length>0" type="button" class="btn btn-lg primary w-100"
        (click)=" selectDelReason($event,possibleValuesSelectDelete[3], otherDelete)"
        i18n="modal_damage|@@validate">Valider</button>
      <button *ngIf="!otherDelete || otherDelete.length<1" type="button" class="btn btn-lg secondaty w-100"
        style="color: grey;" i18n="modal_damage|@@validate">Valider</button>
    </div>
  </div>
  <div class="col-12 m-0 p-0" *ngIf="openDeleteNotDamage">
    <div class="col-12" style="border-bottom: rgba(169, 169, 172, 0.79) 2px solid;"><i class="fa fa-arrow-left p-2"
        style="cursor: pointer;" aria-hidden="true" (click)='openDeleteNotDamage = false'></i></div>
    <ul>
      <li *ngFor="let reason of possibleValuesSelectDeleteNotDamage" class="deleteValue">
        <p #li class="deleteValueText" (click)='li.classList.add("liCkick"); selectDelReason($event, reason)'>
          {{reason.value}}
        </p>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #navigateButton>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-6 col-md-5 col-lg-4 mt-3">
      <button type="button" class="btn btn-lg danger w-100" (click)="deleteDamage()"><span
          i18n="modal_damage|@@removeDamage">Supprimer ce dommage</span><i class="fa fa-check  float-right mt-1"
          aria-hidden="true" *ngIf="isValidated() === false"></i></button>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-4 mt-3">
      <button type="button" class="btn btn-lg primary w-100" (click)="validateDamage()"><span
          i18n="modal_damage|@@validateDamagenext">Confirmer & dommage suivant</span><i
          class="fa fa-check float-right mt-1" aria-hidden="true" *ngIf="isValidated()"></i></button>
    </div>
    <div class="col* mt-3" *ngIf="settings && settings.accessibility && settings.accessibility.fastTrackComp">
      <app-comparison-modal [button]='"fastTrack"' [vehicleId]="tchek.vehiclePtr.id" [tchekId]="tchekId"
        (onTchekSelected)="openComparison($event)">
      </app-comparison-modal>
    </div>
  </div>

  <div class="row justify-content-center  ">
    <div class="col* mt-3 d-none d-md-block">
      <ng-container *ngTemplateOutlet="nextDamage"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #nextDamage>
  <div class="blackBg">
    <p class="textCenterWhite d-inline-flex d-sm-none w-100">
      <i *ngIf="index > 0" class="fa fa-angle-left fa-lg m-2 link p5" aria-hidden="true"
        (click)="changedamage($event,'previous')"></i>
      <i *ngIf="(index < numberDamages-1) && isValidated() !== undefined" class="fa fa-angle-right fa-lg m-2 link p5"
        aria-hidden="true" (click)="changedamage($event,'next')"></i>
      <span *ngIf="index === numberDamages - 1 && !end" (click)="changedamage($event,'end')"
        class="textCenterWhite d-block d-sm-none w-100 p5 link" style="text-align: center;">
        Fin
      </span>
    </p>
    <p *ngIf="!end" class="textCenterWhite d-block d-sm-none w-100 p5" style="text-align: center;">
      {{index + 1}} <span i18n="modal_damage|@@on">sur</span> {{numberDamages}}
    </p>
    <p *ngIf="end" class="textCenterWhite d-block d-sm-none w-100 p5" style="text-align: center;">
      <span i18n="modal_damage|@@end"> Fin</span>
    </p>
    <p class="textCenterWhite  d-none d-sm-block  w-100" style="text-align: center;">
      <i *ngIf="index > 0" class="fa fa-angle-left fa-lg m-2 link mr-1" aria-hidden="true"
        (click)="changedamage($event,'previous')"></i>
      <span class="p5" *ngIf="!end">{{index + 1}} <span i18n="modal_damage|@@on">sur</span>
        {{numberDamages}}</span>
      <span class="p5" i18n="modal_damage|@@end" *ngIf=" end">Fin</span>
      <span class="p5 link" (click)="changedamage($event,'end')" *ngIf="index === numberDamages - 1 && !end">Fin</span>
      <i *ngIf="(index < numberDamages-1) && isValidated() !== undefined" class="fa fa-angle-right fa-lg m-2 link  ml-1"
        aria-hidden="true" (click)="changedamage($event,'next')"></i>
    </p>
  </div>
</ng-template>

<ng-template #confidenceTemplate>
  <div class="linetxt" i18n="modal_damage|@@confidence">CONFIANCE</div>
  <div class="confidence {{confidence.style}}">
    <p class="textCenterWhite">{{confidence.value}}</p>
  </div>
</ng-template>


<!-- PAGE  -->
<div class="damagecontrol-container container" *ngIf="updatePage === false && currentDamage && end !== true">


  <div class="row  justify-content-end  mb-2">
    <div class="col* mt-3 linetxt align-self-end">
      <span i18n="modal_damage|@@immat"></span> {{tchek.vehiclePtr.immat }}
      <span *ngIf="settings && settings.vehicle && settings.vehicle.orNumber && tchek.vehiclePtr.or"> - <span
          i18n="modal_damage|@@or">O.R.
          :</span> {{tchek.vehiclePtr.or }}</span>
      <span *ngIf="settings && settings.vehicle && settings.vehicle.vinNumber && tchek.vehiclePtr.vin"> - <span
          i18n="modal_damage|@@vin">VIN
          :</span> {{tchek.vehiclePtr.vin }}</span>
      - {{tchek.tchekCreatedAt | date:'short'}}
    </div>
  </div>


  <div class="row justify-content-center mb-2" *ngIf="isSuperAdmin && index === 0">
    <div class="col-6 col-sm-4 mt-3">
      <button type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@saveGoReport"
        (click)="redirect('player')">Ouvrir le Player</button>
    </div>
    <div class="col-6 col-sm-4 mt-3">
      <button type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@saveGoPlayer"
        (click)="redirect('report')">Ouvrir le Rapport</button>
    </div>
  </div>


  <div class="row justify-content-center mb-4 mt-3 ">
    <div class="col-12 canvasCol ">
      <app-micro-canvas [roi]='currentRoi'></app-micro-canvas>
    </div>
  </div>

  <div class="row justify-content-center mt-3 ">
    <div class=" col-4 col-sm-2" style="margin-top: auto; margin-bottom:auto;">
      <app-vehicle-svg *ngIf="location" style="margin-top: auto; margin-bottom:auto;" [oneSide]='true'
        class="d-inline-flex" [hilightPart]='location'>
      </app-vehicle-svg>
    </div>
    <div class="d-block d-md-none col-4">
      <ng-container *ngTemplateOutlet="confidenceTemplate"></ng-container>
    </div>
    <div class="col-4 d-flex d-md-none">
      <ng-container *ngTemplateOutlet="nextDamage"></ng-container>
    </div>
    <div class="col-12 col-sm-10 col-md-9 mt-3">
      <div class="roilistContainer">
        <ul class="roiContainer">
          <li *ngFor="let roi of currentDamage.listRoi" class="roiBlock  d-placeholder" style="border: none !important;"
            #roiImageList>
            <!-- Place holder loading -->
            <div *ngIf="roiImageList.classList.contains('d-placeholder')" class="roiImagePlaceholder"></div>
            <!-- roi image -->
            <img crossorigin="anonymous" style="z-index: 11;" class='roiImage'
              (click)="handleRedirectToRoi( roi, $event)"
               [ngClass]="{'d-none' : roiImageList.classList.contains('d-placeholder'),'selectedRoi': currentRoi && currentRoi.id === roi.id,
              'isDeleted ' : roi.isDeleted ||( roi.imagePtr && roi.imagePtr.isDeleted)}" [src]="(roi.imagePtr !== undefined && roi.id !== undefined && roi.imagePtr.file )? 
                   roi.imagePtr.file.url() : roi.bestImageUrl.mini" (error)=" changeSource($event, roi,roiImageList)"
              (load)="roiImageList.classList.add('active');roiImageList.classList.remove('d-placeholder')" />
            <!-- best roi star selector -->
            <img style=" z-index: 11;" class="icon star"
              *ngIf="roi.isDeleted !== true && roi.id === currentDamage.roiPtr.id && roiImageList.classList.contains('active') && !roiImageList.classList.contains('d-placeholder')"
              src="../../../assets/icon/star_filled.svg" alt="">
            <img style="z-index: 10;" (click)='changeBestRoi(roi, $event)' class="icon star"
              *ngIf="roi.isDeleted !== true && roi.id !== currentDamage.roiPtr.id  &&  roiImageList.classList.contains('active') && !roiImageList.classList.contains('d-placeholder')"
              src="../../../assets/icon/star_not_filled.svg" alt="">
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="d-block d-md-none">
    <ng-container *ngTemplateOutlet="navigateButton"></ng-container>
  </div>

  <div class="row justify-content-center">
    <div class="col-12 col-sm-12  col-md-4 mt-2">
      <div class="linetxt" i18n="modal_damage|@@location">Emplacement</div>
      <ng-select [items]="possibleValuesSelectLocation" [bindLabel]="'value'" [bindValue]="'key'"
        [(ngModel)]="currentDamage.location" [virtualScroll]='true' notFoundText="---" [clearable]='false'
        placeholder='Emplacement inconnu' i18n-placeholder="damageControl|@@locationUnknow"
        (change)="changeLocation($event)">
      </ng-select>
    </div>

    <div class="col-12 col-sm-6  col-md-3 mt-2">
      <div class="linetxt" i18n="modal_damage|@@damageType">Type de dégat</div>
      <ng-select [items]="possibleValuesSelectDamage" [bindLabel]="'value'" [bindValue]="'key'"
        [(ngModel)]="currentDamage.type" [virtualScroll]='true' notFoundText="---" [clearable]='false'
        placeholder='---'>
      </ng-select>
    </div>


    <div class="col-12 col-sm-6  col-md-3 mt-2">
      <div class="linetxt" i18n="modal_damage|@@severity">Sévérité</div>
      <ng-select [items]="possibleValuesSelectSeverity" [bindLabel]="'value'" [bindValue]="'key'"
        [(ngModel)]="currentDamage.severity" [virtualScroll]='true' notFoundText="---" [clearable]='false'
        placeholder='---'>
      </ng-select>
    </div>

    <!-- <div class="col-12    col-md-4 mt-2">
      <div class="linetxt" i18n="modal_damage|@@size">Taille</div>
      <ng-select [items]="possibleValuesSelectDamageSize" [bindLabel]="'value'" [bindValue]="'key'"
        [(ngModel)]="currentDamage.sizeRange" [virtualScroll]='true' notFoundText="---" [clearable]='false'
        placeholder='---'>
      </ng-select>
    </div> -->

    <div class="d-none d-md-block col-2 mt-2">
      <ng-container *ngTemplateOutlet="confidenceTemplate"></ng-container>
    </div>
  </div>

  <div class="d-none d-md-block">
    <ng-container *ngTemplateOutlet="navigateButton"></ng-container>
  </div>

</div>

<!-- PAGE SAVE -->
<div class="damagecontrol-container container" *ngIf=" end === true && endSimplified === false">
  <div class="row justify-content-center">
    <div class="col-12  ">
      <p class="endMessage" i18n="modal_damage|@@endMessage">Souhaitez vous ajouter d'autres dommages ?</p>
    </div>
    <div class="col-6 col-sm-2  mt-3">
      <button type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@goreport"
        (click)="redirect('report')">Non</button>
    </div>
    <div class="col-6 col-sm-2 mt-3">
      <button type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@goplayer"
        (click)="redirect('player')">Oui</button>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-4 mt-3">
      <button type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@godashboard"
        (click)="redirect('dashboard')">Non, retour à la liste des scans</button>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col* mt-3 d-block">
      <ng-container *ngTemplateOutlet="nextDamage"></ng-container>
    </div>
  </div>
</div>

<!-- PAGE SAVE SIMPLIFIED -->
<div class="damagecontrol-container container" *ngIf=" end === true && endSimplified === true">
  <div class="row justify-content-center">
    <div class="col-12  ">
      <p class="endMessage" i18n="modal_damage|@@endMessageSimplified">Que voulez-vous faire ?</p>
    </div>
    <div class="col-12 col-sm-4 mt-3">
      <button type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@goreportsimplified"
        (click)="redirect('report')">Rapport PDF</button>
    </div>
    
  </div>
  <div class="row justify-content-center">
    <div class="col-12 col-sm-4 mt-3">
      <button type="button" class="btn btn-lg primary w-100" i18n="modal_damage|@@godashboardsimplified"
        (click)="redirect('dashboard')">Retour au tableau de bord</button>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col* mt-3 d-block">
      <ng-container *ngTemplateOutlet="nextDamage"></ng-container>
    </div>
  </div>
</div>

<!-- PAGE UPDATE IMMAT OR VIN -->
<div class="damagecontrol-container container justify-content-around"
  *ngIf="updatePage  && currentDamage && end !== true">
  <div class="row justify-content-center my-3">
    <div class="col-12 col-md-6" *ngIf="thumbnailUrl">
      <img class="imgUrl" [src]='thumbnailUrl' alt="">
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12    col-md-4 mt-2">
      <div class="linetxt">Date</div>
      <div class="linetxt">{{tchek.tchekCreatedAt | date: 'short'}}</div>
    </div>

    <div class="col-12  col-md-4 mt-2">
      <div class="linetxt" i18n="modal_damage|@@immat">Immat</div>
      <input class="immatInput" [(ngModel)]="tchek.vehiclePtr.immat" type="text" class=""
        i18n-placeholder="damage_control|@@immat">
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12  col-md-4 mt-2" *ngIf="settings && settings.vehicle && settings.vehicle.orNumber">
      <div class="linetxt" i18n="modal_damage|@@or">O.R.</div>
      <input class="orInput" [(ngModel)]="tchek.vehiclePtr.or" type="text" class=""
        i18n-placeholder="damage_control|@@or">
    </div>

    <div class="col-12  col-md-4 mt-2" *ngIf="settings && settings.vehicle && settings.vehicle.vinNumber">
      <div class="linetxt" i18n="modal_damage|@@vin">VIN</div>
      <input class="orInput" [(ngModel)]="tchek.vehiclePtr.vin" type="text" class=""
        i18n-placeholder="damage_control|@@vin">
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-12 col-sm-4 mt-3">
      <button class="btn btn-lg primary w-100" (click)='saveVehicle()'>Valider et procéder à l'inspection</button>
    </div>
  </div>
</div>

<!-- LOADER -->
<div class="damagecontrol-container container" *ngIf="currentDamage === undefined">
  <div class="row justify-content-center">
    <div class="col* loading d-flex">
      <p i18n="modal_damage|@@loading">Chargement</p><img src="../../assets/images/ajax-loader.gif">
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/damage-control/damage-control.component.html